module.exports = __webpack_public_path__ + "static/media/MintButtom_elRoundimage_718961.f95e05ef.png";